import { render, staticRenderFns } from "./_reportMonitoringRibbon.vue?vue&type=template&id=511bd567"
import script from "./_reportMonitoringRibbon.vue?vue&type=script&lang=js"
export * from "./_reportMonitoringRibbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports